import { makeVar } from '@apollo/client';
import { useQuery } from '@tanstack/react-query';
import {
  getActiveGmailCampaignsSummary,
  getGmailAccountMetrics,
  getGmailAccountWatchStatus,
  getGmailAccountQuota,
} from 'services/gmail';

import { useReactiveQuery } from './root';

export const gmailAccountsVar = makeVar([]);

export const useFetchGmailAccounts = ({
  refetchOnMount,
  refetchInterval,
} = {}) =>
  useReactiveQuery('mail/all-authorized-gmail-accounts', gmailAccountsVar, {
    invalidateCacheAfter: 2,
    refetchOnMount,
    refetchInterval,
  });

export const useFetchActiveCampaignsSummary = () => {
  return useQuery(
    ['approximated-campaign-metrics'],
    getActiveGmailCampaignsSummary,
    {
      refetchOnMount: true,
      refetchInterval: 1000 * 60 * 5,
    },
  );
};

export const useFetchGmailAccountMetrics = id => {
  return useQuery(
    ['gmailAccountMetrics', { id }],
    () => getGmailAccountMetrics(id),
    {
      initialData: {},
      refetchOnMount: true,
    },
  );
};

export const useGetGmailAccountWatchStatus = () => {
  return useQuery(
    ['get-gmail-account-watch-status'],
    () => getGmailAccountWatchStatus(),
    {
      refetchOnMount: true,
      initialData: {},
    },
  );
};

export const useGetGmailAccountDailyLimit = () => {
  return useQuery(['get-gmail-account-daily-limit'], getGmailAccountQuota, {
    refetchOnMount: true,
    initialData: {},
  });
};
